import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { useEditorContext } from "features/editor/context/editor";
import { Loading } from "@components";
import { SimilarTranslationItem } from "features/editor/components/panels/SimilarTranslationItem";
import { useFetchSimilarTranslations } from "features/workspaces/hooks/useFetchSimilarTranslations";

export const SimilarTranslationInFile = ({
  onCopyClick,
  isLoading,
  setIsLoading,
}: {
  onCopyClick: any;
  isLoading: boolean;
  setIsLoading: any;
}) => {
  const { fileId } = useParams() as unknown as { fileId: number };
  const { activeItemIndex, list } = useEditorContext();
  const data = list.items[activeItemIndex!] ?? {};

  const [fetchParams, setFetchParams] = useState({
    fileId,
    page: 0,
    pageSize: 10,
    orderBy: "id",
    descendingOrder: false,
    searchOriginal: data.original?.text,
    searchTranslation: "",
    searchIdInFile: "",
    searchGroup: "",
    showInvalidOnly: false,
    showSorted: false,
    searchExact: true,
  });

  useEffect(() => {
    const text = data.original?.text;

    setFetchParams(prev => ({
      ...prev,
      searchOriginal: text,
    }));
  }, [data]);

  // // Fetch translation items
  const { similarTranslations } = useFetchSimilarTranslations(fetchParams, data?.original?.id, setIsLoading);

  return (
    <>
      {isLoading && <Loading className="b-loading--tiny" />}
      {!isLoading && similarTranslations?.length
        ? similarTranslations.map(item => (
            <SimilarTranslationItem
              text={item.translation.text}
              groupName={item.translation.groupName}
              idInFile={item.translation.idInFile}
              originalText={data.original.text}
              key={item.translation.idInFile}
              onCopyClick={onCopyClick}
            />
          ))
        : !isLoading && <Box>No similar translations found</Box>}
    </>
  );
};
